import {css, objectToStyles} from '../utils.js';
import chroma from 'chroma-js';

const themedStyles = css`
    .ddk-container.ddk-container .dash-dropdown {
        ${props => objectToStyles(props.theme.border_style)}
        border-width: ${props => props.theme.control_border.width ?? '1px'};
        border-radius: ${props => props.theme.control_border.radius ?? '4px'};
        border-color: ${props => props.theme.control_border.color};
        background-color: ${props => props.theme.control_background_color};
        color: ${props => props.theme.control_text};
    }

    .ddk-container.ddk-container .dash-dropdown:focus {
        outline-width: 1px;
        outline-style: solid;
        outline-color: var(--Dash-Fill-Interactive-Strong);
        border-color: var(--Dash-Fill-Interactive-Strong);
    }

    .ddk-container.ddk-container .dash-dropown > input,
    .ddk-container.ddk-container .dash-dropdown > input:not([type]) {
        border-color: none;
        border-width: 0;
        border-style: none;
        border-radius: 0;
        padding: initial;
    }

    .ddk-container .layout-header .dash-dropdown-options {
        border-bottom-color: ${props => props.theme.body_text};
    }

    .ddk-container .dash-dropdown-placeholder {
        color: ${props => chroma(props.theme.control_text).alpha(0.8).css()};
    }

    .ddk-container.ddk-container .layout-header .dash-dropdown {
        background-color: inherit;
        color: inherit;
    }

    .ddk-container.ddk-container .dash-dropdown:disabled {
        color: ${props => chroma(props.theme.control_text).alpha(0.8).css()};
        background-color: ${props =>
            chroma(props.theme.control_background_color).alpha(0.5).css()};
    }

    .ddk-container.ddk-container .layout-header .dash-dropdown:disabled {
        color: inherit;
    }

    .ddk-container.ddk-container .layout-header .dash-dropdown {
        background-color: ${props =>
            props.theme.header_background_color !==
                props.theme.background_content &&
            props.theme.control_background_color ===
                props.theme.background_content
                ? 'inherit'
                : props.theme.control_background_color};
        color: ${props =>
            props.theme.control_text === props.theme.text
                ? 'inherit'
                : props.theme.control_text};
    }

    .ddk-container.ddk-container
        .layout-header[style*='background-color:']
        .dash-dropdown {
        background-color: ${props =>
            props.theme.control_background_color ===
            props.theme.background_content
                ? 'inherit'
                : props.theme.control_background_color};
    }

    .ddk-container.ddk-container .layout-header .dash-dropdown:disabled {
        opacity: 0.5;
    }

    .ddk-container.ddk-container .dash-dropdown:disabled .dash-dropdown-value,
    .ddk-container.ddk-container
        .dash-dropdown:disabled
        .dash-dropdown-placeholder {
        background: none;
    }

    .ddk-container.ddk-container .dash-dropdown:hover:not(:disabled) {
        border-color: ${props => props.theme.border};
        cursor: pointer;
    }

    .ddk-container.ddk-container .control .control--label + .control--item .dash-dropdown-wrapper button {
        margin: 0;
    }

    .ddk-container.ddk-container .dash-dropdown-trigger {
        min-height: 38px;
    }
    .ddk-container.ddk-container .dash-dropdown-trigger .dash-dropdown-value {
        color: ${props => props.theme.control_text};
    }

    .ddk-container.ddk-container
        .layout-header:not([style*='color:'])
        .dash-dropdown-placeholder,
    .ddk-container.ddk-container
        .layout-header:not([style*='color:'])
        .dash-dropdown-trigger
        .dash-dropdown-value {
        color: ${props =>
            props.theme.header_text !== props.theme.text &&
            props.theme.control_text === props.theme.text
                ? 'inherit'
                : props.theme.control_text};
    }

    .ddk-container.ddk-container
        .layout-header:not([style*='background-color:'])
        .dash-dropdown
        .dash-dropdown-value {
        background-color: ${props =>
            props.theme.header_background_color !==
                props.theme.background_content &&
            props.theme.control_background_color ===
                props.theme.background_content
                ? 'inherit'
                : chroma(props.theme.control_background_color)
                      .alpha(0.8)
                      .css()};
    }

    .ddk-container.ddk-container .dash-dropdown-clear {
        color: ${props => props.theme.control_text};
    }

    .ddk-container.ddk-container .dash-dropdown-clear:hover {
        color: ${props => props.theme.accent};
    }

    .ddk-container.ddk-container .dash-dropdown-trigger-icon {
        color: ${props => props.theme.body_text};
    }

    .ddk-container.ddk-container .dash-dropdown-trigger-icon:hover {
        color: ${props => props.theme.accent};
    }

    /* Override Radix popover position to be absolute because of .ddk-container
     * styles (namely container-type: inline-size)
     */
    div[data-radix-popper-content-wrapper]:has(.dash-dropdown-content) {
        position: absolute !important;
    }

    .ddk-container.ddk-container .dash-dropdown-content input[type='search'] {
        height: 28px;
        border: none;
        background-color: transparent !important;
    }

    .ddk-container.ddk-container
        .global-controls-bar-item-control
        .dash-dropdown-content
        input[type='search'] {
        height: inherit !important;
    }

    .ddk-container.ddk-container
        .dash-dropdown-wrapper
        .dash-dropdown-action-button:hover,
    .ddk-container.ddk-container
        .dash-dropdown-wrapper
        .dash-dropdown-action-button:focus {
        color: var(--Dash-Fill-Interactive-Strong);
    }
`;
export default themedStyles;
